import { MEDIA_QUERIES } from 'javascripts/constants';
import FooterToggleButton from './FooterToggleButton';

// Toggle button
let footerToggleButton = null;
function onMediaQueryChange(mq) {
  const isDesktop = mq.matches;

  // Deinit on desktop
  if (isDesktop && footerToggleButton) {
    footerToggleButton.deconstructor();
    footerToggleButton = null;

    // Init on mobile
  } else if (!isDesktop && !footerToggleButton) {
    const $toggleButton = document.querySelector('#footer-toggle');
    if ($toggleButton) {
      footerToggleButton = new FooterToggleButton($toggleButton);
    }
  }
}

// Init media query listener
const mql = window.matchMedia(MEDIA_QUERIES.xl);
mql.addListener(onMediaQueryChange);
onMediaQueryChange(mql);
